/**
 * Bucketing-Logik fuer den Studenten-Katalog. Aus CourseCatalog.tsx
 * ausgegliedert, damit der Regression-Test (#275) keine react-admin/MUI/
 * Dependencies mitzieht — CRA-Jest kann das ESM nicht transformieren.
 */

export const LICENSED_KEY = '__licensed__';
export const NO_CATALOG_KEY = '__no_catalog__';

/**
 * Entscheidet, in welchen Bucket ein Kurs im Studenten-Katalog faellt
 * (Section-Header + Sortierschluessel). Issue #275 (HelloBetter unter
 * "BARMER" statt "Lizenzierte Kurse"/"Weitere Kurse").
 *
 * Priorisierung:
 *  1. catalogId vorhanden → lokaler Catalog-Lookup, sonst eingebetteter
 *     catalogName (kommt vom Server fuer Cross-Tenant-Faelle).
 *  2. Nur catalogName vorhanden (Marktplatz-REFERENCE, Catalog im
 *     Licensor-Tenant, daher kein lokaler catalogId-Treffer) → Name als
 *     Bucket, Key haengt am Namen.
 *  3. Licensed-Reference ohne Catalog-Info → "Lizenzierte Kurse".
 *  4. Sonst → "Weitere Kurse".
 */
export function pickCourseBucket(
    course: { catalogId?: number | null; catalogName?: string | null; isLicensedReference?: boolean },
    knownCatalogs: { id: number; name: string }[],
): { key: number | string; name: string } {
    if (course.catalogId !== null && course.catalogId !== undefined) {
        const found = knownCatalogs.find(cat => cat.id === course.catalogId);
        return {
            key: course.catalogId,
            name: found ? found.name : (course.catalogName || 'Weitere Kurse'),
        };
    }
    if (course.catalogName) {
        return { key: `__name__${course.catalogName}`, name: course.catalogName };
    }
    if (course.isLicensedReference) {
        return { key: LICENSED_KEY, name: 'Lizenzierte Kurse' };
    }
    return { key: NO_CATALOG_KEY, name: 'Weitere Kurse' };
}
